import { DownloadOutlined } from "@ant-design/icons";
import { yupResolver } from "@hookform/resolvers/yup";
import { Progress } from "antd";
import FormInput from "components/Common/Form/FormInput";
import MessageFormValidateV2 from "components/Common/MessageFormValidateV2";
import {
  useCreateCodeOfCustomer,
  useDownloadExportFileFromcreateCodeOfCustomer,
  useGetExportFileFromcreateCodeOfCustomer,
  useListCustomer,
} from "hooks";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as yup from "yup";

const initParams = {
  sizePerPage: 30,
  columnFilter: {
    "filter[record_status]": "O",
    "filter[customer_id]": undefined,
  },
  expand: " ",
  page: 1,
  fields: "id,code,name",
  run: false,
};

const AddCodeUseModal = ({
  createCodeSuccessHandle,
  customerDefault,
  isOpenCodeUse,
  toggleCodeUse,
}) => {
  const { addToast } = useToasts();

  const [params, setParams] = useState(initParams);

  const initDefaultValues = {
    customer_ids: [],
    quantity: 1,
  };

  const schema = yup.object().shape({
    customer_ids: yup.array().min(1, "Vui lòng chọn khách hàng"),
    quantity: yup
      .number()
      .min(1, "SL phải lớn hơn 0")
      .max(300, "SL tối đa 300")
      .nullable()
      .typeError("Số lượng phải là một số hợp lệ"),
  });

  const mainForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors, touchedFields },
  } = mainForm;

  // Your custom hook that refetches when params change.
  const {
    // isLoading
    data: customerList,
    refetch: fetchListCustomer,
  } = useListCustomer({ params }, null, null, "customers-add");

  const onSuccessCreateCodeOfCustomer = _data => {
    // toggleCodeUse();
    setTimeout(() => {
      createCodeSuccessHandle();
    }, 2000);
  };

  const onErrorCreateCodeOfCustomer = error => {
    // if (error.code === 422 && error.fields.length > 0) {
    //   error.fields.forEach(item => {
    //     let fieldName = item.field;
    //     switch (item.field) {
    //       case "common":
    //         addToast(item.message, {
    //           appearance: "error",
    //           autoDismiss: true,
    //         });
    //         break;
    //       default:
    //         break;
    //     }
    //     setError(fieldName, {
    //       type: "manual",
    //       message: formConvertErrorMessage(item.message, t),
    //     });
    //   });
    // }
  };

  const {
    isLoading: isLoadingCreateCodeOfCustomer,
    mutate: mutateCreateCodeCustomer,
    data: dataCreateCodeCustomer,
    reset: resetCreateCodeCustomer,
  } = useCreateCodeOfCustomer(
    onSuccessCreateCodeOfCustomer,
    onErrorCreateCodeOfCustomer
  );

  const {
    isLoading: isLoadingGetExportFileFromcreateCodeOfCustomer,
    mutate: mutateGetExportFileFromcreateCodeOfCustomer,
    data: dataGetExportFileFromcreateCodeOfCustomer,
    reset: resetGetExportFileFromcreateCodeOfCustomer,
  } = useGetExportFileFromcreateCodeOfCustomer(response => null, null);

  useEffect(() => {
    if (dataCreateCodeCustomer?.data?.batch_id) {
      mutateGetExportFileFromcreateCodeOfCustomer({
        batch_id: dataCreateCodeCustomer?.data?.batch_id,
      });
    }
  }, [dataCreateCodeCustomer]);

  const onExportSuccess = response => {
    if (response?.data) {
      const outputFilename = `CodeGeneratedOfCustomer-${Date.now()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      toggleCodeUse();
    }
  };

  const {
    isLoading: isLoadingDownloadExportFileFromcreateCodeOfCustomer,
    mutate: mutateDownloadExportFileFromcreateCodeOfCustomer,
    reset: resetDownloadExportFileFromcreateCodeOfCustomer,
  } = useDownloadExportFileFromcreateCodeOfCustomer(onExportSuccess, null);

  useEffect(() => {
    if (
      dataGetExportFileFromcreateCodeOfCustomer?.data?.auth_status &&
      dataCreateCodeCustomer?.data?.batch_id
    ) {
      switch (dataGetExportFileFromcreateCodeOfCustomer?.data?.auth_status) {
        case "P":
          setTimeout(() => {
            mutateGetExportFileFromcreateCodeOfCustomer({
              batch_id: dataCreateCodeCustomer?.data?.batch_id,
            });
          }, 1000);
          break;
        case "A":
          mutateDownloadExportFileFromcreateCodeOfCustomer({
            batch_id: dataCreateCodeCustomer?.data?.batch_id,
          });
          break;
        default:
          break;
      }
    }
  }, [dataGetExportFileFromcreateCodeOfCustomer]);

  // A ref to hold the pending promise resolver from loadOptions.
  const pendingPromiseRef = useRef(null);

  // Trigger fetch when params.run is true.
  useEffect(() => {
    if (params.run) {
      fetchListCustomer();
    }
  }, [params, fetchListCustomer]);

  // When customerList updates, resolve the pending promise (if any).
  useEffect(() => {
    if (pendingPromiseRef.current && customerList) {
      const items = customerList.items || [];
      const meta = customerList.meta || {};

      const options = items.map(i => ({
        value: i.code,
        label: `${i.code} - ${i.name}`,
      }));
      // Determine if more pages are available.
      const hasMore = meta.currentPage < meta.pageCount;
      const { resolve, page } = pendingPromiseRef.current;
      resolve({
        options,
        hasMore,
        additional: { page: page + 1 },
      });
      pendingPromiseRef.current = null;
    }
  }, [customerList, pendingPromiseRef.current]);

  const resetApi = () => {
    resetCreateCodeCustomer();
    resetDownloadExportFileFromcreateCodeOfCustomer();
    resetGetExportFileFromcreateCodeOfCustomer();
  };

  // Set default selected customer when modal opens.
  useEffect(() => {
    if (isOpenCodeUse) {
      setValue(
        "customer_ids",
        customerDefault
          ? [
              {
                value: customerDefault?.code,
                label: `${customerDefault.code} - ${customerDefault.name}`,
              },
            ]
          : [],
        { shouldValidate: true }
      );
      setValue("quantity", 1, { shouldValidate: true });
    } else {
      resetApi();
    }
  }, [isOpenCodeUse]);

  // The loadOptions function triggers a refetch by updating params after a debounce.
  const loadOptions = (searchQuery, loadedOptions, additional) => {
    return new Promise((resolve, reject) => {
      pendingPromiseRef.current = {
        resolve,
        page: additional.page,
        searchQuery,
      };
      setParams(prev => ({
        ...prev,
        page: additional.page,
        columnFilter: {
          ...prev.columnFilter,
        },
        keywords: searchQuery,
        run: true,
      }));
    });
  };

  const handleToggleModal = () => {
    toggleCodeUse();
  };

  const onSubmit = values => {
    mutateCreateCodeCustomer({
      codes: values?.customer_ids?.map(c => {
        return {
          key: c?.value,
          quantity: values?.quantity,
        };
      }),
    });
  };

  return (
    <Modal
      size="lg"
      role="dialog"
      autoFocus={true}
      centered={true}
      isOpen={isOpenCodeUse}
      toggle={handleToggleModal}
    >
      <ModalHeader toggle={handleToggleModal}>Tạo thêm mã</ModalHeader>
      <ModalBody>
        <div>
          <Label htmlFor="collector_id_current">
            Khách hàng tạo mã mới (Tối đa 10 KH)
          </Label>
          <Controller
            control={control}
            name="customer_ids"
            render={({ field }) => (
              <AsyncPaginate
                {...field}
                isClearable
                debounceTimeout={500}
                defaultMenuIsOpen={!customerDefault}
                isMulti
                placeholder="Chọn khách hàng"
                loadOptions={loadOptions}
                additional={{ page: 1 }}
                onChange={value => {
                  // Enforce maximum of 10 selections.
                  if (value && value.length > 10) {
                    addToast("Đã đủ 10 KH", {
                      appearance: "warning",
                      autoDismiss: true,
                    });
                    return;
                  }
                  field.onChange(value);
                }}
              />
            )}
          />
          <MessageFormValidateV2 errors={errors} fieldName={"customer_ids"} />
          <div className="mt-2"></div>
          <div style={{ width: "185px" }}>
            <FormInput
              mainForm={mainForm}
              // isDisabled={true}
              fieldName="quantity"
              type="number"
              t={null}
              title={"Số lượng mã tạo cho mỗi KH (Tối đa 300)"}
              placeholder={"Nhập số lượng"}
            />
          </div>
          {dataCreateCodeCustomer?.data?.batch_id && (
            <div
              className="text-center d-flex gap-2"
              style={{
                flexDirection: "column",
              }}
            >
              <h4 className="text-success"> Xuất danh sách mã đã tạo:</h4>
              <Progress
                size="small"
                type="circle"
                percent={
                  dataGetExportFileFromcreateCodeOfCustomer?.data
                    ?.auth_status === "A"
                    ? 100
                    : 50
                }
                format={percent => `${percent < 100 ? `Loading` : "Hoàn tất"} `}
              />
              <div
                className="d-flex align-items-center justify-content-center gap-2 text-success"
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                <DownloadOutlined />
                Tải file
              </div>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex gap-2">
          <Button onClick={toggleCodeUse}>Đóng</Button>
          <Button
            color="primary"
            className="btn-label"
            type="button"
            disabled={isLoadingCreateCodeOfCustomer}
            onClick={() => {
              resetApi();
              handleSubmit(onSubmit)();
            }}
            // disabled={isLoadingUpdate}
          >
            <i className="bx bx-save label-icon"></i>
            Xác nhận tạo
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AddCodeUseModal;
